var render = function render(){var _vm=this,_c=_vm._self._c;return _c('BasePageLayout',{attrs:{"title":"Журнал действий"}},[_c('d-action-journal-page',{attrs:{"table-titles":_vm.tableTitles,"table-fields":_vm.tableFields,"group-enum":_vm.groupEnum,"action-type-enum":_vm.actionTypeEnum}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }